var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13Kougyou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A456D;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,16c-0.1,0.4-0.2,0.8-0.3,1.2l1.9,1.1l-2,3.5l-1.9-1.1c-0.3,0.3-0.5,0.6-0.9,0.9l1.1,1.9l-3.5,2l-1.1-1.9 c-0.4,0.1-0.8,0.2-1.2,0.3V26h-4v-2.2c-0.4-0.1-0.8-0.2-1.2-0.3l-1.1,1.9l-3.5-2l1.1-1.9c-0.3-0.3-0.6-0.5-0.9-0.9l-1.9,1.1l-2-3.5 l1.9-1.1c-0.1-0.4-0.2-0.8-0.3-1.2H2v-4h2.2c0.1-0.4,0.2-0.8,0.3-1.2l-1.9-1l2-3.5l1.9,1.1C6.8,7,7,6.7,7.4,6.4L6.3,4.6l3.5-2 l1.1,1.9c0.4-0.1,0.8-0.2,1.2-0.3V2h4v2.2c0.4,0.1,0.8,0.2,1.2,0.3l1.1-1.9l3.5,2l-1.1,1.9c0.3,0.3,0.6,0.5,0.9,0.9l1.9-1.1l2,3.5 l-1.9,1.1c0.1,0.4,0.2,0.8,0.3,1.2h2v4h-2.2V16z M14,8c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S17.3,8,14,8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13Kougyou);
export default __webpack_public_path__ + "static/media/13_kougyou.229556ebf8a81dcc10d52dde6d6fa70d.svg";
export { ForwardRef as ReactComponent };